module.exports = __webpack_public_path__ + "img/redEnvelopedRainTimeBackground.6db37ee9.png";